import { render, staticRenderFns } from "./CurrencyFormSell.vue?vue&type=template&id=86a40812&"
import script from "./CurrencyFormSell.vue?vue&type=script&scoped=true&lang=js&"
export * from "./CurrencyFormSell.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports